import proj4 from "proj4";
import * as turf from "@turf/turf";

const sourceCRS =
  "+proj=tmerc +x_0=1500000 +lon_0=-3.45233333 +k_0=0.9996 +ellps=intl +pm=12.45233333333333";
const targetCRS = "+proj=longlat +datum=WGS84 +no_defs";

proj4.defs("sourceCRS", sourceCRS);
proj4.defs("targetCRS", targetCRS);

export const convertGeoJSONCoordinatesFromShp = (geojsonData) => {
  return geojsonData.map((feature) => {
    if (feature.geometry && feature.geometry.coordinates) {
      const convertedCoordinates = feature.geometry.coordinates.map(
        (coordSet) => {
          return coordSet.map((coord) =>
            proj4("sourceCRS", "targetCRS", coord),
          );
        },
      );

      return {
        ...feature,
        geometry: {
          ...feature.geometry,
          coordinates: convertedCoordinates,
        },
      };
    }
    return feature;
  });
};

export const calculateCentroid = (polygon) => {
  if (!polygon || polygon.length === 0) return null;
  let sumLat = 0,
    sumLng = 0;
  const numPoints = polygon.length;
  polygon.forEach(([lat, lng]) => {
    sumLat += lat;
    sumLng += lng;
  });
  return [sumLat / numPoints, sumLng / numPoints];
};

export const calculatePolygonMetrics = (coordinates) => {
  try {
    if (!coordinates || coordinates.length < 3) {
      return { area: 0, centroid: [0, 0] };
    }

    if (
      coordinates[0][0] !== coordinates[coordinates.length - 1][0] ||
      coordinates[0][1] !== coordinates[coordinates.length - 1][1]
    ) {
      coordinates.push(coordinates[0]);
    }

    const turfPolygon = turf.polygon([coordinates]);

    const area = turf.area(turfPolygon);

    const centroid = turf.centroid(turfPolygon);
    const [centroidX, centroidY] = centroid.geometry.coordinates;

    return { area, centroid: [centroidX, centroidY] };
  } catch (error) {
    console.error(error);
  }
};

export const enrichPolygonsWithArea = (polygons) => {
  let totalArea = 0;
  const enrichedPolygons = polygons.map((polygon) => {
    const { position } = polygon;
    const { area, centroid } = calculatePolygonMetrics(position);
    totalArea += area || 0;
    return {
      ...polygon,
      area: Math.round(area * 100) / 100,
      centroid: centroid.map((c) => Math.round(c * 100) / 100),
    };
  });
  return {
    polygons: enrichedPolygons,
    totalArea: Math.round(totalArea * 100) / 100,
    totalAreaHectares: Math.round((totalArea / 10000) * 100) / 100,
  };
};
